import React from "react";
import Form from "../../HelperComponents/Form/Form";
import { Card, CardContent } from "../ui/card";

type WebsiteProfileProps = {
  userProfile: any;
};

const WebsiteProfile = (props: WebsiteProfileProps) => {
  const fields = [
    {
      id: "aboutMe",
      title: "About Me",
      type: "Text",
      value: props.userProfile?.AboutMe,
      visible: true,
      multiline: true,
      maxlength: 1000,
      characterLimit: 1000,
      description:
        "Provide a personal description expressing what you would like others to know about you.",
      destinations: [{ destination: "userProfile", fieldName: "AboutMe" }],
    },
    {
      id: "professionalBiography",
      title: "Professional Biography",
      type: "Text",
      value: props.userProfile?.Professionalbiography,
      visible: true,
      multiline: true,
      maxlength: 1000,
      characterLimit: 1000,
      destinations: [
        { destination: "userProfile", fieldName: "Professionalbiography" },
      ],
    },
    {
      id: "prefix",
      title: "Prefix",
      type: "Text",
      value: props.userProfile?.Prefix,
      visible: true,
      destinations: [{ destination: "userProfile", fieldName: "Prefix" }],
    },
    {
      id: "suffix",
      title: "Suffix",
      type: "Text",
      value: props.userProfile?.Suffix,
      visible: true,
      destinations: [{ destination: "userProfile", fieldName: "Suffix" }],
    },
    {
      id: "officialTitle",
      title: "Official Title",
      type: "Text",
      value: props.userProfile?.OfficialTitle,
      visible: true,
      destinations: [
        { destination: "userProfile", fieldName: "OfficialTitle" },
      ],
    },
  ];

  return (
    <div className="editProfile-container">
      <Card className="card">
        <CardContent>
          <Form fields={fields} columns={3} mode="update" />
        </CardContent>
      </Card>
    </div>
  );
};

export default WebsiteProfile;
